var url;
if (location.hostname == "localhost"){
	url ='https://gcaapi.uniwebdemo.com/public/admin/'
}else{
	url ='https://gcaapi.uniwebdemo.com/public/admin/' 
}
const config = {
	url
}

export default config;	